var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenulistactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10.3333C2.5 10.6095 2.72386 10.8333 3 10.8333H8.66667C8.94281 10.8333 9.16667 10.6095 9.16667 10.3333V3C9.16667 2.72386 8.94281 2.5 8.66667 2.5H3C2.72386 2.5 2.5 2.72386 2.5 3V10.3333ZM2.5 17C2.5 17.2761 2.72386 17.5 3 17.5H8.66667C8.94281 17.5 9.16667 17.2761 9.16667 17V13C9.16667 12.7239 8.94281 12.5 8.66667 12.5H3C2.72386 12.5 2.5 12.7239 2.5 13V17ZM10.8333 17C10.8333 17.2761 11.0572 17.5 11.3333 17.5H17C17.2761 17.5 17.5 17.2761 17.5 17V9.66667C17.5 9.39052 17.2761 9.16667 17 9.16667H11.3333C11.0572 9.16667 10.8333 9.39052 10.8333 9.66667V17ZM11.3333 2.5C11.0572 2.5 10.8333 2.72386 10.8333 3V7C10.8333 7.27614 11.0572 7.5 11.3333 7.5H17C17.2761 7.5 17.5 7.27614 17.5 7V3C17.5 2.72386 17.2761 2.5 17 2.5H11.3333Z",
    fill: "#00B0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenulistactive);
export default __webpack_public_path__ + "static/media/menulistactive.2fd5d3490f7e27af9cde101fb72b8196.svg";
export { ForwardRef as ReactComponent };